import { FC, memo } from 'react';

import { useBlock } from './hooks/useBlock';
import { Block as BlockType } from './types/Block';
import { BlockProps } from './types/BlockProps';

export const BlockComponent: FC<BlockProps<BlockType>> = ({ block }) => {
  const { Block } = useBlock(block);

  return <Block block={block} />;
};

export const Block = memo(BlockComponent);
